var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pcg-btn',{staticClass:"prk-button",attrs:{"round":"","text":"download_doc","disabled":_vm.disabled,"icon":_vm.iconDoc},on:{"click":_vm.downloadDoc}})}
var staticRenderFns = []

export { render, staticRenderFns }